export default __webpack_public_path__ + "static/media/Vector_103_check_mark.3e078cef.svg";